export const dateHelperService = {
  formattedDateFromUTS: (unixTimestamp) => {
    const dateObj = new Date(unixTimestamp);
    const formatted = dateWithMonthAbbreviation(dateObj);
    return formatted;
  },

  unixTimestampToDateTime: (timestamp) => {
    return new Date(timestamp * 1000);
  },
};

const dateWithMonthAbbreviation = (dat) => {
  let today = new Date(dat);
  let day = "" + today.getDate();
  if (today.getDate() < 10) {
    day = "0" + day;
  }

  let month = today.toLocaleString("default", { month: "short" }); // Get 3-letter abbreviation (e.g., 'Jan')

  return day + "/" + month + "/" + today.getFullYear();
};
